import Model from '~/models/base'

export default abstract class Hand extends Model {
  public abstract cardCount(): number
}
